import { useMutation } from 'react-query'
import request from '../request'

export const useAddVendorAccountsToOrganization = () => {
  return useMutation(({ data }: { data: any }) =>
    request({
      url: `/admin/dsp/accounts`,
      method: 'POST',
      data,
    }),
  )
}
